import React, { useState } from "react";
import { getImageBaseUrl } from "../services/s3-utils";
import SvgCaretRight from "../icons/SvgCaretRight";

function FaqAccordion({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="border border-light-color bg-white p-5 rounded-md shadow-[0_1px_12px_0_#15295208]">
      <div
        className="flex gap-3.5 justify-between items-center cursor-pointer"
        onClick={toggle}
      >
        <p className="font-medium p-sm text-main mb-0">{question}</p>

        <SvgCaretRight
          className={`transition-all duration-300 rotate-90 text-light ${
            isOpen ? "rotate-180 transition-all duration-300" : ""
          }`}
        />
      </div>

      <div
        className={`max-h-0 overflow-hidden transition-all duration-300  ${
          isOpen ? "mt-4 max-h-[160px]" : ""
        }`}
      >
        <h6 className="text-[#535393] text-[12px] max-w-[650px]">{answer}</h6>
      </div>
    </div>
  );
}

export default FaqAccordion;
